import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_LAYTIME_EVENTS'),
  ...asyncTypes('CREATE_LAYTIME_EVENTS')
};

export default TYPES;
